module.exports = __webpack_public_path__ + "img/body-bk.3c782ed2.webp";